import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Text } from '@chakra-ui/react';
import { Loader } from '@googlemaps/js-api-loader';
import { renderSanitizedHtml, useSemanticTypography } from '@whitbread-eos/utils';
import React, { useEffect, useRef } from 'react';
import theme from '../../theme';
import { HotelMap } from './components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HotelDirections(_ref) {
  var _data$hotelInformatio;
  var data = _ref.data,
    apiKey = _ref.apiKey,
    t = _ref.t;
  var hotelMapRef = useRef(null);
  var getTypographyProps = useSemanticTypography();
  var _ref2 = (_data$hotelInformatio = data === null || data === void 0 ? void 0 : data.hotelInformation) !== null && _data$hotelInformatio !== void 0 ? _data$hotelInformatio : '',
    coordinates = _ref2.coordinates,
    directions = _ref2.directions,
    brand = _ref2.brand;
  var latitude = coordinates === null || coordinates === void 0 ? void 0 : coordinates.latitude;
  var longitude = coordinates === null || coordinates === void 0 ? void 0 : coordinates.longitude;
  var fillColor = getFillColorMarker();
  useEffect(() => {
    var loader = new Loader({
      apiKey,
      version: 'weekly',
      libraries: []
    });
    loader.load().then(() => {
      if (hotelMapRef !== null && hotelMapRef !== void 0 && hotelMapRef.current && latitude && longitude) {
        var _google = window.google;
        var hotelMap = new _google.maps.Map(hotelMapRef.current, {
          center: {
            lat: latitude,
            lng: longitude
          },
          zoom: 13
        });
        new _google.maps.Marker({
          position: {
            lat: latitude,
            lng: longitude
          },
          map: hotelMap,
          icon: getMarkerIconByBrand()
        });
      }
    });
  }, [brand, latitude, longitude]);
  return _jsxs(Box, {
    mb: "2xl",
    children: [_jsx(Flex, _objectSpread(_objectSpread({}, hotelDirectionsWrapperStyle), {}, {
      sx: {
        '@media print': {
          display: 'none'
        }
      },
      children: _jsxs(Flex, {
        direction: "column",
        w: "full",
        children: [_jsx(Text, _objectSpread(_objectSpread(_objectSpread({}, hotelDirectionsHeadingLayoutStyles), getTypographyProps(hotelDirectionsHeadingLegacyTypography, hotelDirectionsHeadingSemanticTypography)), {}, {
          "data-testid": "hotelDirections-label",
          children: t('booking.confirmation.hotelDirections')
        })), _jsx(Box, _objectSpread(_objectSpread({}, mapBoxStyles), {}, {
          sx: {
            '@media print': {
              display: 'none'
            }
          },
          children: _jsx(HotelMap, {
            latitude: latitude,
            longitude: longitude,
            brand: brand,
            apiKey: apiKey,
            fillColor: fillColor
          })
        })), _jsx(Box, _objectSpread(_objectSpread(_objectSpread({}, hotelDirectionsLayoutStyles), getTypographyProps(hotelDirectionsLegacyTypography, hotelDirectionsSemanticTypography)), {}, {
          "data-testid": "hotelDirections-directions",
          children: renderSanitizedHtml(directions)
        }))]
      })
    })), _jsxs(Box, {
      display: "none",
      sx: {
        '@media print': {
          display: 'block'
        }
      },
      children: [_jsx(Text, {
        fontSize: "md",
        fontWeight: "semibold",
        children: t('booking.confirmation.hotelDirections')
      }), _jsx(Box, _objectSpread(_objectSpread({}, mapBoxStyles), {}, {
        display: "flex",
        children: _jsx("img", {
          src: "https://maps.googleapis.com/maps/api/staticmap?center=".concat(latitude, ",").concat(longitude, "&zoom=13&size=814x400&markers=color:0x").concat(fillColor.substring(1), "%7C").concat(latitude, ",").concat(longitude, "&scale=2&key=").concat(apiKey),
          alt: 'Google Maps'
        })
      })), _jsx(Box, _objectSpread(_objectSpread(_objectSpread({}, hotelDirectionsLayoutStyles), getTypographyProps(hotelDirectionsLegacyTypography, hotelDirectionsSemanticTypography)), {}, {
        children: renderSanitizedHtml(directions)
      }))]
    })]
  });
  function getFillColorMarker() {
    var fillColor = theme.colors.btnSecondaryEnabled;
    if ((brand === null || brand === void 0 ? void 0 : brand.toLowerCase()) === 'hub') {
      fillColor = theme.colors.hubPrimary;
    }
    if ((brand === null || brand === void 0 ? void 0 : brand.toLowerCase()) === 'zip') {
      fillColor = theme.colors.zipPrimary;
    }
    return fillColor;
  }
  function getMarkerIconByBrand() {
    return _objectSpread(_objectSpread({}, defaultPinStyles), {}, {
      fillColor,
      anchor: new google.maps.Point(15, 30)
    });
  }
}
var MapPinPath = 'M45.0585 21C45.0585 32.598 22.8232 63.5 22.8232 63.5C22.8232 63.5 0.587891 32.598 0.587891 21C0.587891 9.40202 10.543 0 22.8232 0C35.1034 0 45.0585 9.40202 45.0585 21Z';
var defaultPinStyles = {
  path: MapPinPath,
  fillOpacity: 1,
  strokeWeight: 2,
  strokeColor: theme.colors.baseWhite,
  rotation: 0,
  scale: 0.5
};
var mapBoxStyles = {
  h: {
    xl: '25rem',
    mobile: '9.75rem'
  },
  borderRadius: '8px',
  mb: 'lg'
};
var hotelDirectionsHeadingLayoutStyles = {
  mb: 'lg'
};
var hotelDirectionsHeadingLegacyTypography = {
  fontWeight: 'semibold',
  fontSize: '2xl',
  lineHeight: '4'
};
var hotelDirectionsHeadingSemanticTypography = {
  textStyle: 'heading-m'
};
var hotelDirectionsLayoutStyles = {
  color: 'darkGrey1'
};
var hotelDirectionsLegacyTypography = {
  fontWeight: 'normal',
  fontSize: 'md'
};
var hotelDirectionsSemanticTypography = {
  textStyle: 'body-m-regular'
};
var hotelDirectionsWrapperStyle = {
  w: 'full',
  border: '1px solid var(--chakra-colors-lightGrey1)',
  borderRadius: '3px',
  p: 'lg'
};